<template>
    <div class="login-container">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <div>
                <h1>SIM卡连接管理平台</h1>
            </div>
            <el-form-item prop="accountName">
                <el-input v-model.trim="loginForm.accountName" placeholder="账号" prefix-icon="el-icon-user" size="large" > </el-input>
                <div class="showRememberAccount" v-if="showAccountsPanel">
                    <RememberAccount @func="getAccountFormSon" ></RememberAccount>
                </div>
                
            </el-form-item>
            <el-form-item prop="pwd">
                <el-input v-model.trim="loginForm.pwd" placeholder="密码" prefix-icon="el-icon-lock" show-password size="large" @keyup.native.enter="handleLogin"></el-input>
            </el-form-item>
            <el-checkbox v-model="rememberMe">记住我</el-checkbox>
            <el-form-item>
                <el-button type="primary" class="login-btn" @click.prevent = "handleLogin" size="large">登录</el-button>
            </el-form-item>

            <el-popover trigger="hover" class="qrcode-show">
                <div style="text-align: center">
                    <p >扫码登录微信公众号</p>
                    <img style="width:120px; height: 120px;" src="@/assets/qrCode.png"> 
                </div>
                <a slot="reference" >微信公众号链接</a>
                <a slot="reference" href="http://crm1.519liuliang.com/" target="_blank">旧系统登录</a>
                
            </el-popover>
           

        </el-form>


        <el-dialog title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" :show-close="false">
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="原密码：">
                    <el-input v-model.trim="modifyPwdForm.oldPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model.trim="modifyPwdForm.newPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain">
                    <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="modifyPwd">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="实名认证" :visible.sync="auth.isAuth"  width="600px" :show-close="false">
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="auth"  label-width="100px">
                <el-form-item label="姓名：" prop="nickname">
                    <el-input v-model.trim="auth.nickname"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                    <el-input v-model.trim="auth.phone" ></el-input>
                </el-form-item>
                 <el-form-item label="验证码：">
                    <el-input style="width:30%" v-model.trim="auth.smsCode"  clearable> </el-input>
                    <el-button class="codeBtn" type="primary" @click="sendCode()">发送验证码</el-button>
                </el-form-item>
                <el-form-item label="身份证号：" prop="cardCode">
                    <el-input v-model.trim="auth.cardCode"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">上传身份证正面：</div>
                            <img v-else :src="frontImgUrl" alt="" width="150" height="150">  
                </el-form-item>
                 <el-form-item label="身份证反面：">
                    <input  type="file" ref="file2">
                     <div v-if="!existBackImg">上传身份证反面</div>
                            <img v-else :src="backImgUrl" alt="" width="150" height="150">  
                </el-form-item>
                <el-form-item label="实名认证状态">
                    <el-input v-model.trim="auth.stateName" disabled="disabled"></el-input>
                </el-form-item>
                 <el-form-item label="审核备注：">
                    <el-input v-model.trim="auth.remark" disabled="disabled"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel2">取 消</el-button>
                <el-button type="primary" @click="agentAuth">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="实名认证通知" :visible.sync="istoAuth"  width="600px" :show-close="false">
            <p>尊敬的代理商：为全力配合国务院联席办“断卡”行动，有效防止打击犯罪分子利用物联网卡进行违法犯罪活动，现要求所有合作商必须完成账户实名认证，实名完成后，对各合作商账号起到保护作用。</p><br/>
             <p>1、实名认证三要素，姓名、身份证号码、手机号码必须一致通过国政通实名认证。</p><br/>
             <p>2、请务必填写真实信息，如盗用他人信息进行实名认证，我司会追究一切法律责任。</p><br/>
             <p>3、合作商账户后期如果出现纠纷，公司只承认该账户实名信息人为该账户实际拥有人。</p><br/>
             <p>4、请各合作商仔细梳理自己的渠道，如发现不遵守信息安全规则的下级合作商，请主动解除合作关系，终止一切业务往来，以免影响自己的账户。</p><br/>
             <p>5、请各合作商必按照运营商规则销售，杜绝一切风险，务必要求终端用户实名到使用人，严禁一切线上销售，禁止在新疆、西藏、云南、广西等敏感诈骗地区使用，若未遵守以上要求，出现任何违规、违法、诈骗、被投诉举报等，由此产生的一切法律责任及经济纠纷，由实名人承担。</p><br/>
             <p>6、如有出现违法、违规行为，我司将协助公安提供该账户对应的实名认证信息，请各合作商销售过程务必谨慎，做好销售记录。</p><br/>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel1">取 消</el-button>
                <el-button type="primary" @click="istoAuthName">同 意</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {login} from '@/api/user.js'
import {sysRequest} from '@/api/customizedRequest.js'
import { mapActions } from "vuex";

import RememberAccount from '@/component/RememberAccount'
export default {
    components: {RememberAccount },
    name: 'login',
    data(){
        var checkNewPwd = (rule, value, callback) => {
            if(value.length > 16 || value.length < 6){
                return callback(new Error('请输入6 ~ 16位密码'))
            }
            callback();
        };
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };
        return {
            loginForm: {
                accountName: '',
                pwd: ''
            },
            loginRules: {
                accountName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },
            existBackImg: false,
            auth:{
                isAuth:false,
                nickname:'',
                phone:'',
                cardCode:'',
                smsCode:'',
                stateName:'',
                remark:''
            },
             verifiedSrcList:[],
            rememberMe:false,
            backImgUrl:'',
            frontImgUrl:'',
            handImgUrl:'',
            //修改密码
            modifyPwdVisible:false,
            modifyPwdTip:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            istoAuth:false,
            pwdRules: {
                newPwd: [
                    {validator: checkNewPwd, trigger: 'blur'}
                ],
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },

            qrCodeUrl:window.location+'assets/alipay.png',
        }
    },
    methods: {
        ...mapActions("menu", {
            setNickName: "setNickName",
            setBtns:"setBtns"
        }),
        getAccountFormSon(data){
            if(data.account.length > 0){
                this.loginForm.accountName = data.account;
                this.loginForm.pwd = data.password;
            }
        },
        sendCode(){
            var data={
                userPhone:this.auth.phone
            }
            sysRequest('authNickname/sms/code', data, 'post').then(res => {
                var code = res.data.code;
                if(code == 200){
                    this.$message.success('发送成功！');
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },
        istoAuthName(){
              var dar={
                                'iccid':''
                             }
                                //查询信息
                            sysRequest('authNickname/agent/list/my',dar, 'post').then(res => {
                            var code = res.data.code;
                            if(code == 200){
                                this.auth.nickname=res.data.data.nickname;
                                this.auth.phone=res.data.data.phone;
                                this.auth.cardCode=res.data.data.cardCode;
                                this.auth.stateName=res.data.data.stateName;
                                this.auth.remark=res.data.data.remark;
                                this.existBackImg=true;
                                this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
                                this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
                                this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
                              }
                           });

                         this.auth.isAuth=true;
        },
        handleLogin(){
            // this.$alert('系统维护中', {confirmButtonText: '确定',
            //     type: 'warning'
            // });
            // return;
            this.$refs.loginForm.validate(valid => {
                if(valid){       
                    login(this.loginForm).then(res => {                     
                        if(res.data.code == 200){
                            localStorage.setItem('token', res.data.data.token);
                            localStorage.setItem('id', res.data.data.id);
                            localStorage.setItem('agentId', res.data.data.agentId);
                            //判断是否实名
                            if(res.data.data.isAuth==1){ // 已实名
                              this.$store.commit('menu/setToken', res.data.data.token);
                              this.$store.commit('menu/setId', res.data.data.id);
                              var nickName = res.data.data.nickName;
                              this.setNickName(nickName);
                              this.setBtns(res.data.data.actionCodes);
                              this.$router.push('AdminHome');
                              if(this.rememberMe){
                                this.setAutoCompleteData("loginAccounts", this.loginForm.accountName+'/'+this.loginForm.pwd, 8);
                              }
                            }else{
                             this.istoAuth=true;
                           }

                        }else if(res.data.code == 410){
                            let token = res.data.data.token;
                            let id = res.data.data.id;
                            localStorage.setItem('token', token);
                            this.modifyPwdForm.id = id;
                            this.modifyPwdTip = res.data.message;
                            this.modifyPwdVisible = true;
                        }
                        else if(res.data.code == 400){
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    return;
                }
            })
        },

        //修改密码
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            let s = '<span style="color: #fd5353;">'+"为保证账户安全，请不要轻易泄露自己的账户及密码。"+'</span>'
                            this.$alert('修改密码成功！请使用新密码重新登录。'+s, '提示', 
                                { confirmButtonText: '确定', 
                                dangerouslyUseHTMLString: true, 
                                callback: action => {
                                    window.location.href = window.location;
                                }
                            });
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },
         agentAuth(){
            //var data =  JSON.parse(JSON.stringify(this.auth));
            var data= new FormData();
            console.log(this.$refs.file1)
            data.append('backUrl',this.$refs.file1.files[0]);
            data.append('frontUrl',this.$refs.file2.files[0]);
            data.append('nickname',this.auth.nickname);
            data.append('phone',this.auth.phone);
            data.append('cardCode',this.auth.cardCode);
            data.append('smsCode',this.auth.smsCode)
            sysRequest('authNickname/agent/insert', data, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                             this.$message.success('请等待客服进行实名确认！');
                             this.auth.isAuth=false;
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
        },

        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
        },
         cancel1(){
            this.istoAuth = false;
        },
         cancel2(){
            this.auth.isAuth = false;
        },
    },

    computed: {
        showAccountsPanel: function () {
            let account = this.getAutoCompleteData('loginAccounts');
            if(account!=null && account!=undefined && account.length > 0){
                if(this.loginForm.accountName.length > 0){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }
    },

    created(){
        
    },

    mounted () {


    }
}
</script>

<style lang="less" scoped>
    .login-container {
        position: relative;
        height: 100%;
        background: url('./../../assets/bg_1.png') no-repeat;
        .login-form {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 300px;
            height: 310px;
            margin: -180px 0 0 -200px;
            padding: 50px 50px 0 50px;
            background: #f5f6f9;
            h1 {
                text-align: center;
                color: #128bf1;
                font-size: 26px;
                margin-bottom: 20px;
            }
            .login-btn {
                width: 50%;
                margin: 15px 0 0 25%;
            }
            .link {
                float: right;
                margin: 10px -26px 0 0;
            }
        }

        .showRememberAccount{
            position: absolute;
            box-sizing: border-box;
            width: 100%;
            background: #f7f7f7;
            border: 1px solid #dcdfe6;
            border-radius: 5px;
            z-index: 9;
        }

        .qrcode-show{
            width: 300px;
            a{
                font-size: 14px;
            }

            a:last-child{
                margin-left: 132px;
            }

        }
    }

</style>

